var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-table-cell",
      class: {
        "c-table__cell__red": _vm.data.violationFullNameCell.isRedCell,
        "c-table__cell__blue": _vm.data.violationFullNameCell.isBlueCell,
        "c-table__cell__white":
          !_vm.data.violationFullNameCell.isRedCell &&
          !_vm.data.violationFullNameCell.isBlueCell,
      },
    },
    [
      _c("div", { staticClass: "c-table__cell-value" }, [
        _c("div", { staticClass: "c-table__cell__icon-wrapper" }, [
          _c(
            "svg",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.data.violationFullNameCell.isImportantFoul ||
                    _vm.data.violationFullNameCell.workerId === 129,
                  expression:
                    "data.violationFullNameCell.isImportantFoul || data.violationFullNameCell.workerId === 129",
                },
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover blur",
                    content: "Важное нарушение",
                    placement: "top",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Важное нарушение',\n          placement: 'top',\n        }",
                  modifiers: { html: true },
                },
              ],
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M7 4V7M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
                  stroke: "#FF238D",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _c("circle", {
                attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
              }),
            ]
          ),
        ]),
        _c("a", { attrs: { href: _vm.linkToWorker, target: "_blank" } }, [
          _vm._v(" " + _vm._s(_vm.data.violationFullNameCell.workerName) + " "),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }